import {
  sem1_2023_2024,
  sem2_2023_2024,
  sem1_2024_2025,
  sem2_2024_2025,
  sem1_2025_2026,
  sem2_2025_2026,
  sem1_2026_2027,
} from "./callender";

export const fallbackCalendars = [
  {
    id: 1,
    year: "2026 - 2027",
    info: "Academic calendar",
    term: [{ id: 1, sem: "Semester One", calendar: sem1_2026_2027 }],
  },
  {
    id: 2,
    year: "2025 - 2026",
    info: "Academic calendar",
    term: [
      { id: 1, sem: "Semester one", calendar: sem1_2025_2026 },
      { id: 2, sem: "Semester Two", calendar: sem2_2025_2026 },
    ],
  },
  {
    id: 3,
    year: "2024 - 2025",
    info: "Academic calendar",
    term: [
      { id: 1, sem: "Semester one", calendar: sem1_2024_2025 },
      { id: 2, sem: "Semester Two", calendar: sem2_2024_2025 },
    ],
  },
  {
    id: 4,
    year: "2023 - 2024",
    info: "Academic calendar",
    term: [
      { id: 1, sem: "Semester one", calendar: sem1_2023_2024 },
      { id: 2, sem: "Semester Two", calendar: sem2_2023_2024 },
    ],
  },
];
